import {Button, Text} from "@mantine/core";
import { FreightCarrierCreateForm } from "./freight-carrier.create.form";
import { useModals } from "@mantine/modals";
import { Plus } from "tabler-icons-react";

interface Props {
    onSubmitForm:(values:any) => void,
}

export function FreightCarrierCreateButton({ onSubmitForm }:Props) {
    const modals = useModals();

    async function _onSubmitForm(values:any){
        await onSubmitForm(values);
        modals.closeAll();
    }

    const renderFreightCarrierForm = () => {
        modals.openModal({
            withCloseButton:true,
            closeOnClickOutside:true,
            closeOnEscape:true,
            size:"900",
            overflow:'outside',
            title: (
                <Text size={'xl'}>Create New Freight Carrier</Text>
            ),
            children: (
                <FreightCarrierCreateForm onSubmitQuery={_onSubmitForm}/>
            ),
        })
        return false;
    }

    return (
        <Button leftIcon={<Plus size={18}/>} onClick={renderFreightCarrierForm}>
            New Freight Carrier
        </Button>
    )
}
